import React, {Component} from 'react';
import Slider from 'react-slider'
import "./UnitTopAudioPlayer.css";
import * as Helper from "../../utils/Helper";

class UnitTopAudioPlayer extends Component{
    constructor(props) {
        super(props);

        this.state = {
            isPlay: false,
            isMuted: false,
            volume: 100,
            allTime: 0,
            currentTime: 0,
            value:10,
            playRate: 1.0,
            audioSrc: props.src
        };
    }
    //播放按钮
    play=()=>{
        this.setState({
            isPlay: !this.state.isPlay
        })
    }

    millisecondToDate(time) {
        const second = Math.floor(time % 60);
        let minite = Math.floor(time / 60);
        return `${minite}:${second >= 10 ? second : `0${second}`}`;
    }

    controlAudio(value) {
        const audio = this.audio;
        audio.volume = value / 100;
        this.setState({
            volume: value,
            isMuted: !value
        });
    }

    // 该视频已准备好开始播放
    onCanPlay = () => {
        const audio = this.audio;
        this.setState({
            allTime: audio.duration,
        });
    };

    // 当前播放位置改变时执行
    onTimeUpdate = () => {
        const audio = this.audio;

        this.setState({
            currentTime: audio.currentTime,
        });
        if (audio.currentTime === audio.duration) {
            this.setState({
                isPlay: false,
            });
        }
    };

    /// 点击了工具栏上的重新播放按钮
    onControlRePlayPress = () =>{
        if (this.audio) {
            this.audio.currentTime = 0;
            this.audio.play();
            this.setState({
                currentTime: 0,
                isPlay: true,
            });
        }
    }

    playAudio = () => {
        this.audio.play();
        this.setState({
            isPlay: true,
        });
    };

    otherPlay = (path) => {
        if (this.audio) {
            if (!this.audio.onended) {
                this.audio.onended = () => {
                    if(this.props.onPlayEnded){
                        this.props.onPlayEnded();
                    }
                }
            }

            this.setState({
                isPlay: true,
                audioSrc: path,
            }, ()=>{this.audio.play()});
        }
    }

    otherStop = () => {
        if(this.audio){
            this.setState({
                isPlay: false,
                audioPath: "",
            },()=>{
                this.audio.pause();
                this.audio.currentTime = 0;
            });
        }
    }

    pauseAudio = () => {
        this.audio.pause();
        this.setState({
            isPlay: false,
        });
    };

    /// 点击了工具栏上的快进/快退按钮
    onControlForwardPress = (kind) => {
        if (this.audio && kind !=="") {
            let curPlayTime = this.state.currentTime;
            let duration = this.state.allTime;
            let changeVal = 15;
            if(kind === "forward"){
                curPlayTime = curPlayTime + changeVal;
                if(curPlayTime > duration){
                    curPlayTime = duration - 1;
                }
            }else{
                curPlayTime = curPlayTime - changeVal;
                if(curPlayTime <0){
                    curPlayTime = 0;
                }
            }
            this.audio.currentTime = curPlayTime;
            this.audio.play();
            this.setState({
                currentTime: curPlayTime,
                isPlay: true
            })
        }
    }

    //拖动滑块
    onSliderValueChange = (curPlayTime) => {
        let duration = this.state.allTime;
        if(curPlayTime <0){
            curPlayTime = 0;
        }
        if(curPlayTime > duration){
            curPlayTime = duration - 1;
        }

        this.audio.currentTime = curPlayTime;
        this.audio.play();
        this.setState({
            currentTime: curPlayTime,
            isPlay: true
        })
    }

    // 倍速播放
    changePlayRate = () => {
        let num = this.state.playRate;
        switch(num){
            case 1:
                num = 1.5;
                break;
            case 1.5:
                num = 2;
                break;
            case 2:
                num = 0.5
                break;
            default:
                num = 1;
                break;
        }

        this.audio.playbackRate = num;
        this.setState({
            playRate: num,
        });
    };


    render(){
        let {isPlay, isMuted, volume, allTime, currentTime, audioSrc} = this.state;
        let audio_time=currentTime/allTime*100;
        audioSrc = Helper.convertToFileServerPath(audioSrc)
        return(
            <>
                <audio
                    ref={self => this.audio = self}
                    src={audioSrc}
                    preload="true"
                    onCanPlay={this.onCanPlay}
                    onTimeUpdate={this.onTimeUpdate}
                    id={"audioPlayer"}
                >
                    Your browser does not support the audio element.
                </audio>

                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", margin: "0 2px"}}>
                    <div onClick={this.onControlRePlayPress}><i className="fa fa-undo" style={{color:"#A8A8A8", fontSize:"15px", cursor: "pointer"}}></i></div>
                    <div style={{display:"flex", alignItems: "center"}}>
                        <div onClick={() => { this.onControlForwardPress('back') }}><i className="fa fa-backward" style={{color:"#A8A8A8",fontSize:"17px", marginRight: "20px", cursor: "pointer"}}></i></div>
                        <div>
                            {isPlay ? (
                                <div onClick={this.pauseAudio}>
                                    <i className="fa fa-pause-circle" style={{color:"#A8A8A8", fontSize:"30px", cursor: "pointer"}}></i>
                                </div>
                            ) : (
                                <div onClick={this.playAudio}>
                                    <i className="fa fa-play-circle" style={{color:"#FFB400", fontSize:"30px", cursor: "pointer"}}></i>
                                </div>
                            )}
                        </div>
                        <div onClick={() => { this.onControlForwardPress('forward') }}><i className="fa fa-forward" style={{color:"#A8A8A8",fontSize:"17px",marginLeft: "20px", cursor: "pointer"}}></i></div>
                    </div>
                    <div>
                        <div style={{...styles.curRate, cursor: "pointer", textAlign:"center"}} onClick={() => this.changePlayRate()}>
                            {this.state.playRate}x
                        </div>
                    </div>
                </div>
                <div className="unit-top-audio-player" style={{position: "relative", height:15}}>
                    <div className="left-time">{this.millisecondToDate(currentTime)}</div>
                    <div className="audio-player">
                        <Slider
                            max={allTime}
                            value={currentTime}
                            step={0.01}
                            className="horizontal-slider"
                            thumbClassName="example-thumb"
                            trackClassName="example-track"
                            /*onBeforeChange={(value, index) =>
                                console.log(`onBeforeChange: ${JSON.stringify({ value, index })}`)
                            }*/
                            //onChange={(currentTime, index) => console.log(`onChange: ${JSON.stringify({ currentTime, index })}`)}
                            onChange={(value, index) => this.onSliderValueChange(value)}
                            /*onAfterChange={(value, index) =>
                                console.log(`onAfterChange: ${JSON.stringify({ value, index })}`)
                            }*/
                            renderThumb={(props, state) => <div {...props}></div>}
                        />
                    </div>
                    <div className="right-time">{this.millisecondToDate(allTime)}</div>
                </div>
                {/*<div style={{paddingBottom:"3px",display: "flex", justifyContent: "space-between", alignItems: "center", margin: "-7px 2px 0px"}}>
                    <div style={{fontSize:10, marginTop:3}}>{this.millisecondToDate(currentTime)}</div>
                    <div style={{flex:.94}}>
                        <div
                            style={{...styles.speeds}}
                            type="range"
                            onChange={(value) => this.controlAudio(value)}
                            value={isMuted ? 0 : volume}
                        >
                            <div
                                 type="range"
                                 onChange={(value) => this.controlAudio(value)}
                                 value={isMuted ? 0 : volume}
                                 style={{...styles.speedsMotion,width:audio_time + '%'}}
                           >
                           </div>
                           <div
                               type="range"
                               step="0.01"
                               max={allTime}
                               value={currentTime}
                               style={{...styles.speedsBtn, left:audio_time-2+ '%'}}
                               onChange={(value) => this.controlAudio(value)}>
                           </div>
                        </div>
                    </div>
                    <div style={{fontSize:10, marginTop:3}}>{this.millisecondToDate(allTime)}</div>
                </div>*/}
            </>
        )
    }
}

const styles = {
    curRate:{
        border:"1px solid #A8A8A8",
        borderRadius: 100,
        width: 25,
        height: 25,
        paddingTop:2,
        color:"#A8A8A8",
        fontSize: 10,
    },

    speeds:{
    	position: "relative",
    	height: "2px",
    	background: "#A8A8A8",
    	marginTop: "2px",
    	borderRadius: "12px",
    },
    speedsMotion:{
    	width: "30px",
    	height: "100%",
    	background: "#FFB400",
    	position: "absolute",
    	borderRadius: "12px",
    },
    speedsBtn:{
    	width:"10px",
    	height: "10px",
    	borderRadius: "50%",
    	backgroundColor: "#FFB400",
    	backgroundSize: "contain",
    	position: "absolute",
    	left:"30%",
    	top:"-4px",
    	zIndex: "100",
    },
};

export default UnitTopAudioPlayer;
